import { signUp, getCurrentSession } from '../../lib/authentication'

export const fetchAll = () => {
  return getCurrentSession()
    .then((result) => {
      const { accessToken } = result
      return apigClient.adminUsersGet(
        {},
        {},
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
    })
    .then((response) => {
      return response.data.data.Items
    })
}

export const inviteUser = (email, role, brokerageId, inviteUserId) => {
  const body = {
    email,
    role: role,
    broker_id: brokerageId,
    invite_user_id: inviteUserId,
  }

  return apigClient.adminUsersPost({}, body, {}).then((response) => {
    if (response.data.success === true) {
      return true
    } else {
      const error = new Error(response.data.message)
      error.errorCode = response.data.errorCode
      error.user = response.data.user
      error.brokerId = response.data.brokerId
      throw error
    }
  })
}

export const saveUser = (id, firstName, lastName, title, phone, phoneExt, role) => {
  return getCurrentSession()
    .then((result) => {
      const { accessToken } = result
      return apigClient.adminUsersIdPut(
        { id },
        [
          { fieldName: 'firstName', fieldValue: firstName },
          { fieldName: 'lastName', fieldValue: lastName },
          { fieldName: 'title', fieldValue: title },
          { fieldName: 'phone', fieldValue: phone },
          { fieldName: 'phoneExt', fieldValue: phoneExt },
          { fieldName: 'role', fieldValue: role },
        ],
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
    })
    .then((response) => {
      if (!response.data.success) {
        throw new Error(response.data.message)
      }
    })
}

export const updateStatus = (id, status) => {
  return getCurrentSession()
    .then((result) => {
      const { accessToken } = result
      return apigClient.adminUsersIdPut(
        { id: id },
        [{ fieldName: 'status', fieldValue: status }],
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
    })
    .then((response) => {
      if (!response.data.success) {
        throw new Error(response.data.message)
      }
    })
}

export const assignUserToGroup = (loginId) => {
  return getCurrentSession()
    .then((result) => {
      const { accessToken } = result
      return apigClient.assignUserToGroupPost(
        {},
        { loginId: loginId },
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
    })
    .then((response) => {
      if (!response.data || !response.data.groupId) {
        throw new Error(
          (response.data && response.data.message) ||
            `Error in assignUserToGroup ${loginId}`,
        )
      }
    })
}

export const unassignUserToGroup = (loginId) => {
  return getCurrentSession()
    .then((result) => {
      const { accessToken } = result
      return apigClient.unassignUserToGroupPost(
        {},
        { loginId: loginId },
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
    })
    .then((response) => {
      if (!response.data || !response.data.groupId) {
        throw new Error(
          (response.data && response.data.message) ||
            `Error in unassignUserToGroup ${loginId}`,
        )
      }
    })
}

export const updateBrokerage = (id, brokerId) => {
  return getCurrentSession()
    .then((result) => {
      const { accessToken } = result
      return apigClient.adminUsersIdPut(
        { id: id },
        [{ fieldName: 'brokerId', fieldValue: brokerId }],
        {
          headers: {
            Authorization: accessToken,
          },
        },
      )
    })
    .then((response) => {
      if (!response.data.success) {
        throw new Error(response.data.message)
      }
    })
}

export const signupUser = (username) =>
  signUp(username)
    .then((status) => status)
    .catch((error) => error)

export const requestAccess = (userData) => {
  const client = apigClientFactory.newClient()
  return client.usersRequestAccessPost({}, userData)
}
